import { ClientGeoAreaProfileFactTypeEnum } from '@DigitaleDoerfer/digitale-doerfer-api';

import { AreaIcon, ParticipantsIcon, PopulationIcon, WebIcon } from '@/assets';
import type { SVGComponent } from '@/types';

export const FACT_TYPE_ICONS: Record<
  ClientGeoAreaProfileFactTypeEnum,
  SVGComponent
> = {
  [ClientGeoAreaProfileFactTypeEnum.People]: PopulationIcon,
  [ClientGeoAreaProfileFactTypeEnum.AppUsers]: ParticipantsIcon,
  [ClientGeoAreaProfileFactTypeEnum.Url]: WebIcon,
  [ClientGeoAreaProfileFactTypeEnum.Measurement]: AreaIcon
};
